module.exports = __webpack_public_path__ + "img/setting.6b700088.png";